import { CSSObject } from '@chakra-ui/react'
import { Dict } from '@chakra-ui/utils'
import { mode } from '@chakra-ui/theme-tools'
import { DISABLED_OPACITY } from './constants'

export const commonStyle = (props: Dict): CSSObject => {
  const defaultColor = mode('rw1.primary.light.5', 'rw1.primary.dark.5')(props)
  const hoverColor = mode('rw1.primary.light.6', 'rw1.primary.dark.6')(props)
  const borderWidth = 'medium'

  return {
    borderRadius: 'base',

    backgroundColor: mode(
      'rw1.colors.light.white',
      'rw1.colors.dark.white',
    )(props),

    borderWidth,
    borderColor: defaultColor,

    _hover: {
      borderWidth,
      borderColor: hoverColor,
    },

    _disabled: {
      borderWidth,
      borderColor: defaultColor,
      opacity: DISABLED_OPACITY,
    },

    _checked: {
      backgroundColor: defaultColor,
      borderColor: defaultColor,

      _hover: {
        borderColor: hoverColor,
        backgroundColor: hoverColor,
      },
      _disabled: {
        borderColor: defaultColor,
        backgroundColor: defaultColor,
        opacity: DISABLED_OPACITY,
      },
    },
  }
}

export const getAuthBackgroundColor = (props: Dict): CSSObject => ({
  backgroundColor: mode('rw1.secondary.light.0', 'rw1.secondary.dark.0')(props),
})
